import { Component, Input } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { DismissNotification, Notification, NotificationState } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { UI_TOOLS_TRANSLOCO_SCOPE } from '../../ui-tools-transloco-scope';

@Component({
  selector: 'yat-notification-outlet',
  templateUrl: './notification-outlet.component.html',
  styleUrls: ['./notification-outlet.component.scss'],
  providers: [provideTranslocoScope(UI_TOOLS_TRANSLOCO_SCOPE)]
})
export class NotificationOutletComponent {
  constructor(private store: Store) {}

  @Input()
  showLineOnTop = false;

  notifications$: Observable<Notification[]> = this.store.select(NotificationState.notifications);

  dismiss(notification: Notification): void {
    this.store.dispatch(new DismissNotification(notification.id));
  }
}
